import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Space,
  Typography,
  Spin,
  Empty,
  Modal,
  Form,
  Input,
  message,
} from 'antd';
import {
  PlusOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import { BASE_URL, getAuthHeaders } from '../composant/ComposantAPP/Util';

const { Title } = Typography;
const { confirm } = Modal;

const InfluenceursPage = () => {
  const [influenceurs, setInfluenceurs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);

  // Récupération des influenceurs
  const fetchInfluenceurs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/admin/api/getInfluenceurs`, {
        headers: getAuthHeaders(),
      });
      setInfluenceurs(response.data);
    } catch (error) {
      console.error('❌ Erreur chargement influenceurs :', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInfluenceurs();
  }, []);

  // Désactivation d’un compte
  const handleDesactiverCompte = (userId) => {
    confirm({
      title: 'Confirmer la désactivation',
      icon: <ExclamationCircleOutlined />,
      content: 'Êtes-vous sûr de vouloir désactiver ce compte ?',
      okText: 'Oui',
      cancelText: 'Non',
      onOk: async () => {
        try {
          await axios.put(`${BASE_URL}/admin/api/desactiver-compte/${userId}`, null, {
            headers: getAuthHeaders(),
          });
          message.success('Compte désactivé avec succès');
          fetchInfluenceurs();
        } catch (error) {
          console.error('Erreur lors de la désactivation du compte :', error);
          message.error("Erreur lors de la désactivation du compte");
        }
      },
    });
  };

  // Soumission formulaire ajout influenceur
  const handleAddInfluenceur = async (values) => {
    setSubmitLoading(true);
    try {
      await axios.post(`${BASE_URL}/admin/api/influenceur`, values, {
        headers: getAuthHeaders(),
      });
      message.success('Influenceur ajouté avec succès');
      setModalVisible(false);
      form.resetFields();
      fetchInfluenceurs(); // Actualiser la liste
    } catch (error) {
      console.error('Erreur ajout influenceur:', error);
      message.error("Erreur lors de l'ajout");
    } finally {
      setSubmitLoading(false);
    }
  };

  // Colonnes du tableau
  const columns = [
    {
      title: 'Nom',
      dataIndex: ['userSystem', 'nom'],
      key: 'nom',
    },
    {
      title: 'Prénom',
      dataIndex: ['userSystem', 'prenom'],
      key: 'prenom',
    },
    {
      title: 'Téléphone',
      dataIndex: ['userSystem', 'telephone'],
      key: 'telephone',
    },
    {
      title: 'Email',
      dataIndex: ['userSystem', 'email'],
      key: 'email',
    },
    {
      title: 'Statut',
      key: 'statut',
      render: (_, record) => {
        const statut = record.userSystem?.statut_compte;
        return (
          <Space>
            <span>{statut ? 'Actif' : 'Désactivé'}</span>
            {statut && (
              <Button
                type="primary"
                danger
                size="small"
                onClick={() => handleDesactiverCompte(record.userSystem?.id)}
              >
                Désactiver
              </Button>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Title level={3}>Liste des influenceurs</Title>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setModalVisible(true)}
        >
          Ajouter un influenceur
        </Button>

        {loading ? (
          <Spin tip="Chargement des influenceurs..." />
        ) : (
          <Table
            columns={columns}
            dataSource={influenceurs}
            rowKey="id"
            pagination={{ pageSize: 8 }}
            bordered
            scroll={{ x: true }}
            locale={{
              emptyText: <Empty description="Aucun influenceur pour le moment" />,
            }}
          />
        )}
      </Space>

      <Modal
        title="Ajouter un influenceur"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleAddInfluenceur}
        >
          <Form.Item name="nom" label="Nom" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="prenom" label="Prénom" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="telephone" label="Téléphone" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={submitLoading} block>
              Ajouter
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default InfluenceursPage;
